import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";

import trajectoryActionPlanImage from "@/assets/fr/trajectory-illustrations/trajectoryActionPlan.png";
import { PortalContainerContext, UserContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

interface UpsellModalProps {
  children: React.ReactNode;
}

const UpsellModalActionPlan = ({ children }: UpsellModalProps) => {
  const { user } = use(UserContext);
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("trajectory");
  const { sendSegmentEvent } = useSegmentEvent();
  const outboundQueryParamsOptions = useOutboundQueryParams("options");
  const outboundQueryParamsUpgrade = useOutboundQueryParams("upgrade");

  return (
    <InterceptDialog
      show={!user?.policies?.trajectory?.queries["new"]}
      title={t("trajectory:buildActionPlanUpsell.title")}
      description={t("trajectory:buildActionPlanUpsell.description")}
      warningMessage={t("trajectory:buildActionPlanUpsell.warning")}
      portalContainer={container as Element}
      content={
        <img
          src={trajectoryActionPlanImage}
          alt={t("trajectory:buildActionPlanUpsell.imageAltText")}
        />
      }
      footer={
        <>
          <DialogClose asChild>
            <Button
              as="a"
              href={`https://try.hellocarbo.com/meetings/emmanuel-watrinet/rdv-abonnement-carbo-entreprise${outboundQueryParamsUpgrade}`}
              shape="link"
              shouldOpenNewTab
              onClick={() => sendSegmentEvent("clic_CTA_upsell")}
            >
              {t("trajectory:buildActionPlanUpsell.secondaryCta")}
            </Button>
          </DialogClose>
          <DialogClose>
            <Button
              as="a"
              href={`https://meetings-eu1.hubspot.com/emmanuelle-vignial/demo-options-carbo${outboundQueryParamsOptions}`}
              shouldOpenNewTab
              onClick={() => sendSegmentEvent("option_demo")}
            >
              {t("trajectory:buildActionPlanUpsell.primaryCta")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellModalActionPlan;
